module.exports = __webpack_public_path__ + "static/media/institute-19-min.68f62d1e.webp";